import { Button, Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { I18n } from 'aws-amplify';

export const DialogConfirmCreateTicketError = props => {
    const {isOpen, onSubmit, msgConfirm} = props;

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        props.setIsOpen(false);
    };

    const onPressConfirm = () => {
        onSubmit();
        props.setIsOpen(false);
    }

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                {msgConfirm ? msgConfirm : I18n.get('COMMSG030')}
                    {/* <IconButton
                        className="close"
                        onClick={(event, reason) => onCloseConfirm(event, reason)}
                    >
                        <CloseIcon />
                    </IconButton> */}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action" style={{justifyContent: 'center'}}>
                <Button
                    className="confirm-dialog-button btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={onPressConfirm}
                >
                    {I18n.get('COMBTN002')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
